'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$51() {
  this.bky = null;
  this.bkz = false;
}
export { $c_Lpresto_PrestoRouter$$anon$51 as $c_Lpresto_PrestoRouter$$anon$51 };
$p = $c_Lpresto_PrestoRouter$$anon$51.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$51;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$51() {
}
export { $h_Lpresto_PrestoRouter$$anon$51 as $h_Lpresto_PrestoRouter$$anon$51 };
$h_Lpresto_PrestoRouter$$anon$51.prototype = $p;
$p.c1 = (function() {
  if ((!this.bkz)) {
    this.bky = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bkz = true;
  }
  return this.bky;
});
$p.P = (function() {
  return this.c1();
});
var $d_Lpresto_PrestoRouter$$anon$51 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$51, "presto.PrestoRouter$$anon$51", ({
  Or: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$51 as $d_Lpresto_PrestoRouter$$anon$51 };
//# sourceMappingURL=presto.-Presto-Router$$anon$51.js.map
